function trigger(state, payload) {
    let is_modal = !state.modal[payload].modal;
    let navigator = { true: 'backdrop', false: 'modal' }
    state.modal[payload][navigator[is_modal]] = is_modal
    setTimeout(() => {
        state.modal[payload][navigator[!is_modal]] = is_modal
    }, 100)
}
export default { trigger }